var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64896 2.82462C6.41345 3.11666 6.30435 3.57776 6.30435 4.26087V5.13043C6.30435 5.49062 6.01236 5.78261 5.65217 5.78261C5.29199 5.78261 5 5.49062 5 5.13043V4.26087C5 3.5005 5.10829 2.65725 5.63364 2.00581C6.18348 1.32401 7.06306 1 8.26087 1C9.45868 1 10.3383 1.32401 10.8881 2.00581C11.4134 2.65725 11.5217 3.5005 11.5217 4.26087V8.13043C11.5217 8.49062 11.2298 8.78261 10.8696 8.78261C10.5094 8.78261 10.2174 8.49062 10.2174 8.13043V4.26087C10.2174 3.57776 10.1083 3.11666 9.87277 2.82462C9.66174 2.56294 9.23698 2.30435 8.26087 2.30435C7.28476 2.30435 6.86 2.56294 6.64896 2.82462Z",
    fill: "#C2C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.73913C7.44767 8.73913 7.00001 9.1869 7.00001 9.73915C7.00001 10.2914 7.44767 10.7392 8 10.7392C8.55233 10.7392 9 10.2914 9 9.73915C9 9.1869 8.55233 8.73913 8 8.73913ZM5.82609 6.47826C4.96118 6.47826 4.15928 6.57058 3.6258 7.10406C3.09232 7.63754 3 8.43944 3 9.30435V10.1739C3 11.0388 3.09232 11.8407 3.6258 12.3742C4.15928 12.9077 4.96118 13 5.82609 13H10.1739C11.0388 13 11.8407 12.9077 12.3742 12.3742C12.9077 11.8407 13 11.0388 13 10.1739V9.30435C13 8.43944 12.9077 7.63754 12.3742 7.10406C11.8407 6.57058 11.0388 6.47826 10.1739 6.47826H5.82609Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.7e1d6f7b31b116c32cf2789d8f5adf5a.svg";
export { ForwardRef as ReactComponent };